import React, { useEffect, useState } from 'react';

import MaterialTable from 'material-table';

import { table_style, table_translate } from '../../constants/MaterialTable';
import { showMessage } from '../../services/message';
import { api_GET } from '../../services/api_service';

// components 
import FichaRequerimentoTransportador from '../../views/Shared/Transportador/FichaRequerimento';
import FichaRequerimentoDestino from '../../views/Shared/Destino/FichaRequerimento';
import FichaRequerimentoGerador from '../../views/Shared/Gerador/FichaRequerimento';

import { formateDateandTime } from '../../helpers/formats';

import { useAuth } from '../../context/auth';

function ListaDashboardRequerimento({ listShow, handleReturnDashboard }) {
  const { setLoading } = useAuth();


  // pegar os requerimentos pelo status passado
  const [requerimentos, setRequerimentos] = useState([]);

  const [requerimentoVisualizar, setRquerimentoVisualizar] = useState(null);

  const columns = [
    { title: "Requerimento", field: "numeroRequerimento" },
    { title: "CPF/CNPJ", field: "cpf_Cnpj" },
    { title: "Código Cadastro", field: "codigoCadastro" },
    { title: "E-mail", field: "email" },
    { title: "Categoria", field: "categoria" },
    { title: "Etapa", field: "etapa" },
    { title: "Data Solicitacao", field: "dataSolicitacao" },
    { title: "Data ultima Ação", field: "ultimaAcao" },
    { title: "Ação", field: "acao" },
  ];

  useEffect(() => {
    if (listShow && listShow.requerimentos) {
      const _etapa = listShow.etapa === "Rejeitado" ? "Divergente" : listShow.etapa;

      const { requerimentosList } = listShow.requerimentos;

      if (requerimentosList.length > 0) {
        // pegando os requeirimentos pelo status especifico passado
        const _requerimentos = requerimentosList.filter((req) => {
          if (req.etapa === _etapa && req.segmento === listShow.segmento && req.descricao === listShow.descricao) {
            req.ultimaAcao = formateDateandTime(req.ultimaAcao);
            req.dataSolicitacao = formateDateandTime(req.dataSolicitacao);
            return req;
          }
        })
        setRequerimentos(_requerimentos);
      }
    }
    setLoading(false);
  }, []);

  const handleRequerimento = (rowData) => {
    const { requerimentosList } = listShow.requerimentos;
    const requerimento = requerimentosList.filter((req, index) => {
      if (req.requerimento_Id == rowData.requerimento_Id) {
        return req;
      }
    })

    setLoading(true);
    api_GET('requerimento/' + requerimento[0].requerimento_Id)
      .then(result => {
        if (result.data.etapaCadastro == 0 || result.data?.requerimentoGerador?.length == 0) {
          showMessage("Aviso", "Este requerimento está na primeira etapa de preenchimento dos dados e sua ficha não pode ser aberta pois os dados ainda não estão preenchidos!", 'info', null)
          return;
        }
        setRquerimentoVisualizar(result.data)
      })
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  const handleView = (rowData) => {
    handleRequerimento(rowData);
  }

  const handleReturn = () => {
    setRquerimentoVisualizar(null);
  }

  return (
    <div className='content'>
      {requerimentoVisualizar === null &&
        <>
          <button className="btn btn-secondary" onClick={() => handleReturnDashboard()}>
            <i className='fa fa-arrow-left' style={{ marginRight: "10px" }}></i>
            VOLTAR
          </button>
          <MaterialTable
            title={`${listShow.categoria} (${listShow.etapa})`}
            columns={columns}
            data={requerimentos}
            options={{
              exportButton: true,
              columnsButton: true,
              table_style
            }}
            actions={[
              {
                icon: 'search',
                tooltip: 'Visualizar Registro',
                onClick: (event, rowData) => handleView(rowData)
              }
            ]}
            localization={table_translate}
          />
        </>
      }

      {/* mostrar dados dos tipos especificos de cada requerimento */}
      {requerimentoVisualizar && listShow.segmento === "Destino Final" &&
        <FichaRequerimentoDestino
          item={requerimentoVisualizar}
          handleReturn={handleReturn}
          showAcoesGestor={true}
        />}
      {requerimentoVisualizar && (listShow.segmento === "Grande Gerador" || listShow.segmento === "Grande Gerador - PGRCC") &&
        <FichaRequerimentoGerador
          item={requerimentoVisualizar}
          handleReturn={handleReturn}
          showAcoesGestor={true}
        />}
      {requerimentoVisualizar && listShow.segmento === "Transportador" &&
        <FichaRequerimentoTransportador
          item={requerimentoVisualizar}
          handleReturn={handleReturn}
          showAcoesGestor={true}
        />}
    </div>
  );
}

export default ListaDashboardRequerimento;